import "react-toastify/dist/ReactToastify.min.css";

import dynamic from "next/dynamic";
import useAppInitialization from "./useAppInitialization";
import { createContext, Suspense, useContext } from "react";
import { AppProgressBar as ProgressBar } from "next-nprogress-bar";

// Lazy load ToastContainer
const ToastContainer = dynamic(() =>
  import("react-toastify").then((module) => ({
    default: module.ToastContainer,
  })),
);

const AppLoader = dynamic(() => import("./AppLoader"), {
  ssr: false,
});

const MiniTrolley = dynamic(
  () => import("@/components/common/shared/MiniTrolley"),
  {
    ssr: false,
  },
);

const AppInitializationContext = createContext();

export const useAppContext = () => {
  return useContext(AppInitializationContext);
};

export function AppInitialization({ children }) {
  const {
    methods: { dispatch },
    data: { appContextData },
  } = useAppInitialization();

  return (
    <AppInitializationContext.Provider value={appContextData}>
      <ProgressBar
        options={{ showSpinner: false }}
        style={`#nprogress { display: none; }`}
      />

      {/* Suspense fallback is required when using lazy */}
      <Suspense fallback={null}>
        <AppLoader />
        <ToastContainer
          rtl={false}
          theme="light"
          closeOnClick
          draggable={false}
          newestOnTop={true}
          position="top-right"
          pauseOnHover={false}
          pauseOnFocusLoss={false}
          className="custom-toastify"
          style={{
            zIndex: 99999999999,
          }}
        />
        <MiniTrolley dispatch={dispatch} />
      </Suspense>
      {children}
    </AppInitializationContext.Provider>
  );
}
